import { escapeJsonLd } from '@/lib/seo';

interface JsonLdScriptProps {
  data: Record<string, unknown> | null | undefined;
}

export function JsonLdScript({ data }: JsonLdScriptProps) {
  if (!data) return null;
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: escapeJsonLd(data) }}
    />
  );
}
